// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row[data-v-b13c07d8]{display:flex;justify-content:space-between;text-align:left}.foot3 ul[data-v-b13c07d8]{width:50%}.footer[data-v-b13c07d8]{background-color:#000}", ""]);
// Exports
module.exports = exports;
